import { useTranslation } from "react-i18next";
import { AutocompleteType } from "../../../types/autoComplete";
import AutocompleteBase from "../fields/autocompleteBase/AutocompleteBase";
import { AutocompleteRenderGroupParams } from "@mui/material";

type SelectAutocompleteMultiProps = {
  value: AutocompleteType[];
  booleanSelect?: boolean;
  options: AutocompleteType[];
  onChange: (value: AutocompleteType[] | null) => void;
  groupBy?: (option: AutocompleteType) => string;
  renderGroup?: (params: AutocompleteRenderGroupParams) => React.ReactNode;
  translationNamespaces?: string[];
};

export const SelectAutocompleteMulti = ({
  value,
  options,
  onChange,
  translationNamespaces = [],
}: SelectAutocompleteMultiProps) => {
  const { t } = useTranslation([...translationNamespaces, "common"]);
  return (
    <AutocompleteBase<AutocompleteType>
      value={value}
      multiple
      options={options}
      getOptionLabel={(option) => t(`${option.name}`)}
      isOptionEqualToValue={(opt, val) => opt.id === val.id}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          {t(`${option.name}`)}
        </li>
      )}
      onChange={(value: AutocompleteType[] | null) => {
        onChange(value);
      }}
      size="small"
    />
  );
};
